// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"c979237c","167":"7b72bc70","309":"1ef35495","787":"a59c7c77"}[chunkId] + ".chunk.css";
};